/** Same markup as the static splash in index.html, so the hand-over is seamless. */
export function Splash() {
	return (
		<div className="splash" aria-busy="true">
			<span className="splash-logo">SPOT</span>
		</div>
	);
}
